import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { modoSelecaoSimcard } from '../redux/actions/index'
import { useGlobal } from '../stores/useGlobal.js'

export function ResetOnRouteChange() {
  const location = useLocation()
  const dispatch = useDispatch()
  const setSelecionarParqueInteiro = useGlobal(
    (s) => s.setSelecionarParqueInteiro
  )

  useEffect(() => {
    setSelecionarParqueInteiro(false)
    dispatch(modoSelecaoSimcard(false))
  }, [location.pathname, dispatch, setSelecionarParqueInteiro])

  return null
}
